// MerchantLogin.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import './Login.css'; // reuse styles
import { FaArrowLeft } from 'react-icons/fa';
import API_BASE_URL from './config';

const MerchantLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/merchant/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      if (response.ok) {
        localStorage.setItem("merchantId", data.merchant.merchantId);
        navigate('/merchant-dashboard');
      } else {
        alert(data.error || 'Login failed.');
      }
    } catch (error) {
      console.error('Merchant login error:', error);
      alert('An error occurred during login.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async (credentialResponse) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/merchant/auth/google`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: credentialResponse.credential }),
      });

      const data = await response.json();
      if (response.ok) {
        localStorage.setItem("merchantId", data.merchant.merchantId);
        navigate('/merchant-dashboard');
      } else {
        alert('Google login failed.');
      }
    } catch (error) {
      console.error('Google login error:', error);
      alert('An error occurred during Google login.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-header">
          <button className="back-btn" onClick={() => navigate('/')} disabled={loading}>
            <FaArrowLeft />
          </button>
          <h2>Merchant Sign In</h2>
        </div>
        <form onSubmit={handleEmailLogin}>
          <label>Email Address</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={loading} />
          <label>Password</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required disabled={loading} />
          <button type="submit" disabled={loading}>{loading ? 'Processing...' : 'Login as Merchant'}</button>
        </form>
        <div className="google-login">
          <GoogleLogin
            onSuccess={handleGoogleLogin}
            onError={() => {
              alert('Google login failed.');
              setLoading(false);
            }}
          />
        </div>
        <div className="signup-redirect">
          <p>Don't have a merchant account? <span onClick={() => navigate('/merchant-signup')}>Sign Up</span></p>
        </div>
      </div>
    </div>
  );
};

export default MerchantLogin;
